'use strict'
const lodashSet = require('lodash/set')

function chiQuestionHelper(config, context, questionIndex) {
    let self = this
    let question = config.questions[questionIndex]
    
    this.resolveNextQuestion = function (outcome) {
        if(question.outcomesContainer && (question.outcomesContainer.outcomes || []).length > 0) {
            let resultOutcomes = (question.outcomesContainer.outcomes || []).filter((item) => {
                return item.outcome == outcome
            })
    
            if(resultOutcomes.length == 0) {
                goToQuestion(questionIndex + 1)
            } else {
                switch(resultOutcomes[0].reactionType) {
                    case 'nextQuestion': {
                        goToQuestion(questionIndex + 1)
                        break;
                    }
                    case 'jumpToQuestion': {
                        goToQuestion(resultOutcomes[0].jumpToQuestionIndex)
                        break;
                    }
                    case 'endQuiz': {
                        goToQuestion(config.questions.length)
                        break;
                    }
                    default: {
                        goToQuestion(questionIndex + 1)
                        break;
                    }
                }
            }
        } else {
            goToQuestion(questionIndex + 1)
        }
        
        async function goToQuestion(index) {
            if(context.realDevice && config.quiz.rememberPositionForQuiz) {
                let systemId = context.message.systemId
                await context.realDevice.canUpdateData()
                let variables = context.realDevice.variables || {}
                lodashSet(variables, "quizContainerPackage.systemId_"+systemId+".currentPosition" , index)
                context.realDevice.variables = variables
            }
            
            if (index >= config.questions.length) {
                return context.containerNavigation.next()
            } 
            
            let nextSystemId = ((config.questions[index] || {}).question || {}).systemId
            
            if(nextSystemId && config.quiz.missingMessageBehaviour !== "none") {
                switch (config.quiz.missingMessageBehaviour){
                    case "next" : {
                        let allMessages = context.realDevice.allMessages.find(item => (item || {}).systemId == nextSystemId)
                        if(!allMessages) goToQuestion(index + 1) 
                        else context.setCurrentQuestionIndex({ index: index, history: context.currentQuestionIndex.history.concat([index])})
                        break;
                    }
                    case "wait" : {
                        let allMessagesBefore = context.realDevice.allMessages.find(item => (item || {}).systemId == nextSystemId)
                        
                        if(!allMessagesBefore){
                            await context.realDevice.unlock("QuizContainer.message.next")
                            let info = await context.realDevice.getInfo()
                            let infoMessage = info.messages.find(item => (item || {}).systemId == nextSystemId)
                            if(!infoMessage) goToQuestion(index + 1)
                            else context.setCurrentQuestionIndex({ index: index, history: context.currentQuestionIndex.history.concat([index])})
                        }
                        else context.setCurrentQuestionIndex({ index: index, history: context.currentQuestionIndex.history.concat([index])})
                        break;
                    }
                    default : {
                        context.setCurrentQuestionIndex({ index: index, history: context.currentQuestionIndex.history.concat([index])})
                        break;
                    }
                }
            } else {
                context.setCurrentQuestionIndex({ index: index, history: context.currentQuestionIndex.history.concat([index])})
            }
        }
    }
    
    this.triggerOutcome = async function (parentTriggerOutcome, outcome, isFinal) {
        console.log("device.triggerOutcome", questionIndex, outcome, isFinal)
        let closeBeforeFinal = ((context.message || {}).quantities || {}).closeBeforeFinal
        
        if (closeBeforeFinal && isFinal) {
            self.resolveNextQuestion(outcome)
        }
        
        let triggerOutcomeResult = parentTriggerOutcome(outcome, false)
        if (isFinal) {
            if (
                (!question.waitForFinalOutcome || question.waitForFinalOutcome === "default") ? 
                    config.waitForFinalOutcome : 
                    question.waitForFinalOutcome === "yes"
            ) {
                await triggerOutcomeResult
            }
            
            if (!closeBeforeFinal) {
                self.resolveNextQuestion(outcome)
            }
        }
        
        return triggerOutcomeResult
    }
}

function goToFn(config, context) {
    return function (id, options, parameters) {
        if (options && options.internalNavigation) {
            let { index, systemId } = parameters
            if (index !== undefined) {
                context.setCurrentQuestionIndex({ index: index, history: context.currentQuestionIndex.history })
            } else if (systemId !== undefined) {
                let questionIndex = config.questions.findIndex((q) => q.question.systemId === systemId.toString())
                if (questionIndex !== -1) {
                    context.setCurrentQuestionIndex({ index: questionIndex, history: context.currentQuestionIndex.history })
                } else {
                    throw new Error (`Question with systemId : ${systemId} not found in quiz container`)
                }
            }
        } else {                       
            throw new Error ('Internal navigation not allowed')
        }
    }
}

module.exports = {
    chiQuestionHelper: chiQuestionHelper,
    goToFn: goToFn
}